// Module
var code = "<h2 id=\"alec-for-schools\">Alec for Schools</h2> <p>Sign in to Alec to start using this online toolkit.</p> <p><a href=\"https://am.partners.aessuccess.org/partnersB2Bsso/dashboard.htm\" class=\"button--isPrimary\"> Get Started</a></p> ";
// Exports
export default code;